import { type FC, type ReactNode } from 'react';
import { ComponentLoader } from '../../../global/ComponentLoader/ComponentLoader.tsx';

const importFunc = async (): Promise<ReactNode> => {
    const { PdpSharedConditionModalWrapper } = await import(
        /* webpackChunkName: "PdpSharedConditionModalWrapper" */
        './PdpSharedConditionModalWrapper.tsx'
    );
    // Type 'FC<Props>' is not assignable to type 'ReactNode'.
    // @ts-ignore
    return PdpSharedConditionModalWrapper;
};

type Props = {
    itemId: string;

    isOpen: boolean;
    onClose: () => void;
};

const PdpSharedConditionModalLoader: FC<Props> = props => {
    return <ComponentLoader {...props} load={props.isOpen} importFunc={importFunc} />;
};

export { PdpSharedConditionModalLoader };
